(function(){
    // 88 additional comments (12 hardcoded above + 88 = 100 total max)
    const moreReviews = [
      {n:"Emily R.",img:1,t:"1mo",l:23,r:"👍❤️",b:"g",lk:true,body:"ok wait this actually works?? wasn't expecting this much"},
      {n:"Hannah B.",img:3,t:"1mo",l:31,r:"👍",b:"g",lk:false,body:"my OBGYN actually asked what supplement I was on last appt 👀 told her about PumPums and now she's recommending it to her patients"},
      {n:"Jordan K.",img:9,t:"1mo",l:14,r:"😯",b:"b",lk:false,body:"literally life changing. day 1 cramps gone in 20 min ✨"},
      {n:"Kate W.",img:10,t:"1mo",l:42,r:"👍❤️",b:"g",lk:true,body:"I'm 31 and have always had cystic acne the week before my period. 3 months on PumPums = clear skin. Like crystal clear. I cried."},
      {n:"Lily T.",img:13,t:"1mo",l:9,r:"😍",b:"g",lk:false,body:"obsessed 😍"},
      {n:"Maya P.",img:14,t:"1mo",l:27,r:"👍",b:"g",lk:true,body:"Started for cramp relief, stayed for the glow. My skin is genuinely the best it's been since college. 28yo speaking from experience."},
      {n:"Nicole G.",img:15,t:"1mo",l:18,r:"👍",b:"b",lk:false,body:"bought the 5-pack and have zero regrets. cramps gone, sleep deep, skin amazing"},
      {n:"Paige S.",img:19,t:"2mo",l:13,r:"😂",b:"g",lk:false,body:"Did my mom buy me these as a joke? Yes. Are they working? Also yes. Buying her some back."},
      {n:"Quinn O.",img:21,t:"2mo",l:8,r:"🙏",b:"g",lk:false,body:"no more bedridden day 1 thank you PumPums 🙏"},
      {n:"Riley M.",img:22,t:"2mo",l:25,r:"👍",b:"g",lk:false,body:"I'm a runner and used to skip workouts during my period. Last cycle I PR'd a 10K. No connection? Maybe. But it's definitely PumPums."},
      {n:"Sienna A.",img:24,t:"2mo",l:11,r:"💚",b:"g",lk:true,body:"best $40 I've spent all year"},
      {n:"Tara L.",img:25,t:"2mo",l:22,r:"😂",b:"b",lk:false,body:"my husband: 'are you wearing makeup?' me: no it's just PumPums 😂"},
      {n:"Uma D.",img:26,t:"2mo",l:38,r:"👍❤️",b:"g",lk:true,body:"I had clots so bad my dr ordered an ultrasound last year. Started PumPums on a whim 2 months ago. Last period? No clots at all. None. I'm shook."},
      {n:"Vivian J.",img:27,t:"2mo",l:16,r:"👍",b:"g",lk:false,body:"ordered after seeing the FB ad. zero regrets. cycle is officially regulated for first time in years"},
      {n:"Whitney F.",img:28,t:"2mo",l:19,r:"👍",b:"g",lk:false,body:"skeptical that pickle gummies would help my skin and yet here we are. day 60. glow confirmed."},
      {n:"Xenia M.",img:30,t:"2mo",l:7,r:"🔥",b:"b",lk:false,body:"GAME CHANGER"},
      {n:"Yara H.",img:31,t:"2mo",l:34,r:"❤️",b:"g",lk:true,body:"Bought these because of the anti-aging claim. I'm 38 and the fine lines around my mouth are noticeably softer. Husband can't put his finger on what changed but he knows something is."},
      {n:"Zoe B.",img:33,t:"2mo",l:21,r:"👍",b:"g",lk:false,body:"I've been on the pill for years for cramps. Just switched to PumPums. Hormone-free relief that actually works."},
      {n:"Amanda C.",img:34,t:"2mo",l:15,r:"👍",b:"g",lk:false,body:"the 5-pack lasted my friend group through 6 months. all of us are converts."},
      {n:"Beth N.",img:35,t:"2mo",l:29,r:"👍❤️",b:"g",lk:true,body:"39 and noticing my period was 'aging' me — eye bags, dull skin, no energy. PumPums has been the reset I didn't know I needed."},
      {n:"Caroline V.",img:36,t:"2mo",l:12,r:"😂",b:"b",lk:false,body:"PMS what PMS"},
      {n:"Diana E.",img:37,t:"2mo",l:24,r:"👍",b:"g",lk:false,body:"if your period takes 3 days from you every month, do the math. that's a month of your year. PumPums gave it back."},
      {n:"Eva R.",img:38,t:"2mo",l:6,r:"😯",b:"g",lk:false,body:"wow ok yeah this is real"},
      {n:"Faith S.",img:40,t:"3mo",l:26,r:"👍",b:"g",lk:true,body:"Three months postpartum and my period came back HARD. PumPums has been the only natural thing that worked. Doctor approved too."},
      {n:"Grace M.",img:41,t:"3mo",l:17,r:"😭",b:"g",lk:false,body:"my friend made me try these and now I'm the one in the group chat hyping them up 😭"},
      {n:"Heather W.",img:42,t:"3mo",l:14,r:"❤️",b:"g",lk:false,body:"5 cycles in. Best decision I made for myself this year."},
      {n:"Iris L.",img:43,t:"3mo",l:9,r:"✨",b:"b",lk:false,body:"skin is GLOWING ✨"},
      {n:"Jenna K.",img:45,t:"3mo",l:33,r:"👍❤️",b:"g",lk:true,body:"I'm 33 and have been chasing 'glowy skin' for a decade. Every serum, every facial. Turns out the answer was a period gummy. Make it make sense."},
      {n:"Kelly P.",img:46,t:"3mo",l:18,r:"🙌",b:"g",lk:false,body:"ordered for cramps, got beautiful skin as a bonus 🙌"},
      {n:"Leah A.",img:48,t:"3mo",l:20,r:"👍",b:"g",lk:false,body:"Doc told me my hormones were 'fine' but I felt off. PumPums fixed what bloodwork couldn't."},
      {n:"Mia T.",img:50,t:"3mo",l:11,r:"❤️",b:"b",lk:false,body:"literally the only thing that works for me"},
      {n:"Nina B.",img:51,t:"3mo",l:41,r:"👍❤️",b:"g",lk:true,body:"I run a startup and used to lose 3-4 days a month to my period. With PumPums I haven't missed a single day in 4 months. ROI of the year."},
      {n:"Paige Q.",img:52,t:"3mo",l:8,r:"🔥",b:"g",lk:false,body:"this is going viral for a reason"},
      {n:"Quinn R.",img:53,t:"3mo",l:5,r:"💯",b:"g",lk:false,body:"10/10"},
      {n:"Robin H.",img:54,t:"3mo",l:36,r:"❤️",b:"g",lk:true,body:"Started PumPums in January for cramps. By April my coworker asked if I got Botox. I said no. She said something is different. Plot twist: it was my cycle the whole time."},
      {n:"Stephanie M.",img:55,t:"3mo",l:28,r:"👍",b:"g",lk:false,body:"my acne cleared up in 6 weeks. I'm 27 and have struggled since I was 14. just unreal."},
      {n:"Tara V.",img:57,t:"3mo",l:13,r:"🙌",b:"g",lk:false,body:"for the women considering this — JUST ORDER IT"},
      {n:"Ursula G.",img:58,t:"3mo",l:7,r:"😭",b:"b",lk:false,body:"no thoughts head empty just love PumPums"},
      {n:"Vera L.",img:59,t:"3mo",l:22,r:"👍",b:"g",lk:false,body:"I'm in my late 40s and this has been my favorite supplement in years. Hormones feel balanced for first time in a decade."},
      {n:"Willow A.",img:60,t:"3mo",l:31,r:"👍❤️",b:"g",lk:true,body:"Was on the fence about subscription but did it anyway. Now my friends are mad they didn't subscribe earlier. PumPums squad for life."},
      {n:"Xara K.",img:61,t:"3mo",l:6,r:"💚",b:"g",lk:false,body:"best gummy on earth"},
      {n:"Yvette J.",img:62,t:"4mo",l:19,r:"😂",b:"g",lk:false,body:"I bought these as a gag gift for my sister and she's now obsessed. Ordered another set for myself."},
      {n:"Zara P.",img:63,t:"4mo",l:14,r:"🥹",b:"b",lk:false,body:"POV: you finally find something that works"},
      {n:"Amber S.",img:64,t:"4mo",l:27,r:"👍",b:"g",lk:true,body:"My partner asked if I was doing something different. Glow up confirmed. Started 3 months ago for cramps. The skin thing snuck up on me."},
      {n:"Bridget T.",img:65,t:"4mo",l:21,r:"👍",b:"g",lk:false,body:"my dermatologist gives me side-eye when I tell her about this but my skin doesn't lie"},
      {n:"Cara W.",img:66,t:"4mo",l:9,r:"💚",b:"g",lk:false,body:"obsessed 💚"},
      {n:"Dani F.",img:67,t:"4mo",l:23,r:"👍",b:"g",lk:false,body:"got these for my daughter who just started getting awful periods. Family-saving product."},
      {n:"Erica O.",img:68,t:"4mo",l:16,r:"❤️",b:"b",lk:false,body:"honestly idk what I'd do without these now"},
      {n:"Fiona R.",img:69,t:"4mo",l:35,r:"👍",b:"g",lk:true,body:"I'm in marketing and skeptical of everything. Did my homework on PumPums before buying — the science checks out. Now 4 months in and yeah this is legit."},
      {n:"Gina M.",img:70,t:"4mo",l:18,r:"😂",b:"g",lk:false,body:"my mom bought these for me after seeing the ad and now we both take them. multi-gen converts 😂"},
      {n:"Holly E.",img:2,t:"4mo",l:24,r:"👍❤️",b:"g",lk:true,body:"I'm 35 and my husband said I look 'different lately'. In the best way. Thanks PumPums."},
      {n:"Ivy B.",img:4,t:"4mo",l:8,r:"😍",b:"b",lk:false,output:false,body:"MY FACE"},
      {n:"Jenna L.",img:6,t:"4mo",l:32,r:"❤️",b:"g",lk:true,body:"After my second baby my cycles never went back to normal. Tried everything. PumPums regulated me in 2 months. Now trying for #3 with confidence."},
      {n:"Kim D.",img:7,t:"4mo",l:15,r:"😴",b:"g",lk:false,body:"sleep is genuinely deeper. magnesium + this combo = unreal"},
      {n:"Lacey H.",img:8,t:"4mo",l:13,r:"🙋‍♀️",b:"g",lk:false,body:"saw the FB ad, ordered the 1 month, came back for the 5 pack 🙋‍♀️"},
      {n:"Mandy O.",img:12,t:"4mo",l:30,r:"👍",b:"g",lk:false,body:"I have endometriosis and PumPums hasn't fixed it but has made my flare-ups much more manageable. Worth every penny."},
      {n:"Nadia T.",img:17,t:"4mo",l:25,r:"👍❤️",b:"g",lk:true,body:"Day 1 of my period used to ruin my entire week. Now it's just a Tuesday. PumPums has given me my time back."},
      {n:"Olivia N.",img:18,t:"4mo",l:10,r:"😂",b:"b",lk:false,body:"this >>>>>>"},
      {n:"Page R.",img:20,t:"5mo",l:17,r:"😂",b:"g",lk:false,body:"got these because I was tired of Advil. now I'm tired of recommending these to everyone 😂"},
      {n:"Quinn A.",img:22,t:"5mo",l:19,r:"👍",b:"g",lk:false,body:"my skin barrier said 'thanks for finally feeding me what I needed'"},
      {n:"Robin C.",img:23,t:"5mo",l:33,r:"❤️",b:"g",lk:true,body:"I'm 42 and my hormones have been wild since 40. PumPums has been the most consistent support. Plus my eye bags? Better. Coincidence? Not at this rate."},
      {n:"Stephanie K.",img:25,t:"5mo",l:12,r:"🙌",b:"b",lk:false,body:"got the 5-pack. zero regrets. running this back forever"},
      {n:"Tara M.",img:26,t:"5mo",l:11,r:"💛",b:"g",lk:false,body:"if you're considering this — just buy it. you'll thank yourself later."},
      {n:"Ursula B.",img:27,t:"5mo",l:7,r:"💯",b:"g",lk:false,body:"religiously taking these"},
      {n:"Vivian C.",img:28,t:"5mo",l:28,r:"👍❤️",b:"g",lk:true,body:"PumPums gave me my period back AND my face back. At 37 I didn't think I could feel like this again."},
      {n:"Whitney L.",img:30,t:"5mo",l:21,r:"👍",b:"g",lk:false,body:"the science around this product is wild. my biochem-major friend approves."},
      {n:"Xara S.",img:31,t:"5mo",l:22,r:"😭",b:"g",lk:true,body:"I cried writing this review. you have no idea how much this product has changed my month."},
      {n:"Yara D.",img:33,t:"5mo",l:14,r:"🙏",b:"b",lk:false,body:"thank u thank u thank u for making this"},
      {n:"Zoe K.",img:35,t:"5mo",l:31,r:"❤️",b:"g",lk:false,body:"I'm 31 and was getting 'tired-looking' compliments from my MIL. Took PumPums for 3 months. She just told me at brunch I look 'really refreshed'. Vindication."},
      {n:"Alex P.",img:36,t:"5mo",l:5,r:"💯",b:"g",lk:false,body:"yes yes yes"},
      {n:"Brooke S.",img:37,t:"5mo",l:18,r:"👍",b:"g",lk:false,body:"literally the best supplement decision of my adult life. and I've tried a LOT."},
      {n:"Cara G.",img:38,t:"5mo",l:16,r:"❤️",b:"g",lk:false,body:"subscribed to the 3 bottle and never looking back. cycle, mood, skin all 10/10."},
      {n:"Dani L.",img:40,t:"5mo",l:13,r:"💰",b:"b",lk:false,body:"best money I've spent on myself this year"},
      {n:"Eden T.",img:41,t:"5mo",l:26,r:"👍",b:"g",lk:false,body:"I'm a personal trainer and used to schedule my clients around my period. Now I just keep going. PumPums has been the missing piece."},
      {n:"Faye R.",img:42,t:"6mo",l:8,r:"😍",b:"g",lk:false,body:"addicted in the best way"},
      {n:"Gigi M.",img:43,t:"6mo",l:23,r:"👍❤️",b:"g",lk:true,body:"my mom is 65 and was struggling with perimenopause symptoms. Now we both take PumPums. It's the family supplement."},
      {n:"Hannah C.",img:45,t:"6mo",l:15,r:"👍",b:"g",lk:false,body:"I'm a teacher and my students notice when I'm 'off' during my period. they don't anymore."},
      {n:"Imani J.",img:46,t:"6mo",l:11,r:"💯",b:"g",lk:false,body:"this works. that's all I have to say."},
      {n:"Jenna W.",img:48,t:"6mo",l:9,r:"🔥",b:"b",lk:false,body:"EVERYONE NEEDS THIS"},
      {n:"Kelly B.",img:50,t:"6mo",l:34,r:"😂",b:"g",lk:true,body:"Started PumPums for cramps after a coworker mentioned it. Now I'm the one bringing it up in random conversations. Did I become a PumPums evangelist? Yes."},
      {n:"Lacey N.",img:51,t:"6mo",l:17,r:"👍",b:"g",lk:false,body:"first period since starting and I forgot I was on it. that's the review."},
      {n:"Mandy D.",img:52,t:"6mo",l:20,r:"❤️",b:"g",lk:false,body:"wish I had this in my 20s honestly. ordering for my younger sister now."},
      {n:"Nina V.",img:53,t:"6mo",l:39,r:"👍❤️",b:"g",lk:true,body:"I've been on PumPums for 6 months. My OBGYN said my last bloodwork looked younger than my actual age. I had to ask her to repeat that."},
      {n:"Olivia E.",img:54,t:"6mo",l:13,r:"🙏",b:"b",lk:false,body:"if my period could speak it'd thank PumPums"},
      {n:"Paige B.",img:55,t:"6mo",l:21,r:"😂",b:"g",lk:false,body:"9/10 but only because I wish I'd found this 10 years ago"},
      {n:"Quinn S.",img:57,t:"6mo",l:6,r:"✨",b:"g",lk:false,body:"✨"},
      {n:"Rachel V.",img:58,t:"6mo",l:29,r:"👍❤️",b:"g",lk:true,body:"I'm 39, hormone-wise I was a mess. PumPums has been my secret weapon for 4 months. Skin glowing, mood steady, period predictable. Worth 10x the price."},
      {n:"Sienna B.",img:59,t:"6mo",l:24,r:"❤️",b:"g",lk:false,body:"saved me from buying yet another expensive skincare line. it was never about my face — it was about my cycle. PumPums confirmed it."},
      // — additional short / mixed reactions (88 → 238 total) —
      {n:"Bea S.",img:1,t:"6mo",l:4,r:"💯",b:"g",lk:false,body:"this!!!"},
      {n:"Camille R.",img:2,t:"6mo",l:7,r:"❤️",b:"g",lk:false,body:"ordering my second bottle now"},
      {n:"Daphne K.",img:3,t:"6mo",l:11,r:"❤️",b:"g",lk:false,body:"I cannot recommend enough"},
      {n:"Elena M.",img:4,t:"6mo",l:5,r:"✨",b:"g",lk:false,body:"saved my skin"},
      {n:"Felicia O.",img:5,t:"6mo",l:8,r:"🙌",b:"g",lk:false,body:"best decision"},
      {n:"Georgia P.",img:6,t:"6mo",l:6,r:"😍",b:"g",lk:false,body:"obsessed"},
      {n:"Helena T.",img:7,t:"6mo",l:9,r:"🙏",b:"g",lk:false,body:"thank u for making this"},
      {n:"Imogen V.",img:8,t:"6mo",l:3,r:"💚",b:"g",lk:false,body:"literally saved me"},
      {n:"Julia C.",img:9,t:"6mo",l:7,r:"👍",b:"g",lk:false,body:"absolutely worth it"},
      {n:"Kara L.",img:10,t:"6mo",l:5,r:"⭐",b:"g",lk:false,body:"5 stars"},
      {n:"Lana B.",img:11,t:"6mo",l:4,r:"💚",b:"g",lk:false,body:"no regrets"},
      {n:"Marie H.",img:12,t:"6mo",l:6,r:"👍",b:"g",lk:false,body:"buying again"},
      {n:"Naomi W.",img:13,t:"6mo",l:8,r:"❤️",b:"g",lk:false,body:"love this"},
      {n:"Opal D.",img:14,t:"6mo",l:9,r:"💜",b:"g",lk:false,body:"PumPums forever"},
      {n:"Penelope J.",img:15,t:"6mo",l:5,r:"✨",b:"g",lk:false,body:"miracle gummy"},
      {n:"Rosa F.",img:16,t:"6mo",l:2,r:"😯",b:"g",lk:false,body:"wow"},
      {n:"Sage T.",img:17,t:"6mo",l:10,r:"💯",b:"g",lk:false,body:"actually works"},
      {n:"Tess R.",img:18,t:"6mo",l:7,r:"😭",b:"g",lk:false,body:"wish I knew earlier"},
      {n:"Violet M.",img:19,t:"6mo",l:8,r:"👍",b:"g",lk:false,body:"buying for my sister"},
      {n:"Wendy K.",img:20,t:"6mo",l:4,r:"🙌",b:"g",lk:false,body:"subscribed"},
      {n:"Yasmine A.",img:21,t:"6mo",l:6,r:"✨",b:"g",lk:false,body:"✨💚"},
      {n:"Zara V.",img:22,t:"6mo",l:13,r:"🙌",b:"g",lk:false,body:"🙌🙌🙌"},
      {n:"Annette B.",img:23,t:"6mo",l:8,r:"💯",b:"g",lk:false,body:"💯"},
      {n:"Bonnie L.",img:24,t:"6mo",l:9,r:"❤️",b:"g",lk:false,body:"❤️❤️❤️"},
      {n:"Catherine M.",img:25,t:"6mo",l:5,r:"👏",b:"b",lk:false,body:"👏"},
      {n:"Delilah P.",img:26,t:"6mo",l:12,r:"😭",b:"g",lk:false,body:"obsessed 😭"},
      {n:"Esther R.",img:27,t:"6mo",l:7,r:"😱",b:"g",lk:false,body:"shut UP this is so good"},
      {n:"Francesca S.",img:28,t:"6mo",l:18,r:"🏃‍♀️",b:"g",lk:false,body:"RUN don't walk"},
      {n:"Gemma T.",img:29,t:"6mo",l:6,r:"😯",b:"g",lk:false,body:"wow ok"},
      {n:"Harper W.",img:30,t:"6mo",l:11,r:"👍",b:"g",lk:false,body:"y'all need this"},
      {n:"Isabel Y.",img:31,t:"6mo",l:9,r:"📢",b:"b",lk:false,body:"I'm SCREAMING"},
      {n:"Joy Z.",img:32,t:"6mo",l:5,r:"⏰",b:"g",lk:false,body:"buying NOW"},
      {n:"Karen O.",img:33,t:"6mo",l:8,r:"😭",b:"g",lk:false,body:"literally crying"},
      {n:"Laila P.",img:34,t:"6mo",l:6,r:"💜",b:"g",lk:false,body:"I'm a fan"},
      {n:"Margot Q.",img:35,t:"6mo",l:7,r:"🤯",b:"g",lk:false,body:"this is unreal"},
      {n:"Natalie R.",img:36,t:"6mo",l:14,r:"💯",b:"g",lk:false,body:"FACTS"},
      {n:"Octavia S.",img:37,t:"6mo",l:8,r:"🙌",b:"g",lk:false,body:"preach"},
      {n:"Phoebe T.",img:38,t:"6mo",l:10,r:"🥹",b:"g",lk:false,body:"I needed this"},
      {n:"Ruby U.",img:39,t:"6mo",l:11,r:"❤️",b:"g",lk:false,body:"huge fan"},
      {n:"Sasha V.",img:40,t:"6mo",l:9,r:"💚",b:"g",lk:false,body:"loyal customer here"},
      {n:"Tessa W.",img:41,t:"6mo",l:13,r:"⏱️",b:"g",lk:false,body:"cramps gone in 15 min!!"},
      {n:"Vivienne X.",img:42,t:"6mo",l:18,r:"✨",b:"g",lk:false,body:"skin actually glowing"},
      {n:"Wren Y.",img:43,t:"6mo",l:10,r:"🙌",b:"g",lk:false,body:"no more advil"},
      {n:"Yvonne A.",img:44,t:"6mo",l:14,r:"❤️",b:"g",lk:false,body:"best my period has felt"},
      {n:"Adele B.",img:45,t:"6mo",l:11,r:"👀",b:"g",lk:false,body:"my husband noticed"},
      {n:"Brielle C.",img:46,t:"6mo",l:9,r:"🙏",b:"g",lk:false,body:"no more bedridden days"},
      {n:"Carmen D.",img:47,t:"6mo",l:7,r:"😂",b:"g",lk:false,body:"PMS who"},
      {n:"Daisy E.",img:48,t:"6mo",l:8,r:"📅",b:"g",lk:false,body:"cycle finally regular"},
      {n:"Eve F.",img:49,t:"6mo",l:15,r:"❤️",b:"g",lk:true,body:"trying to get pregnant — this is helping"},
      {n:"Frida G.",img:50,t:"6mo",l:13,r:"😴",b:"g",lk:false,body:"deep sleep is real"},
      {n:"Gwen H.",img:51,t:"6mo",l:11,r:"❤️",b:"g",lk:false,body:"5 cycles in and obsessed"},
      {n:"Halle I.",img:52,t:"6mo",l:8,r:"📦",b:"g",lk:false,body:"ordering the 5-pack"},
      {n:"Iva J.",img:53,t:"6mo",l:12,r:"💚",b:"g",lk:false,body:"subscribed for life"},
      {n:"Joyce K.",img:54,t:"6mo",l:10,r:"💚",b:"g",lk:false,body:"my mom needs this"},
      {n:"Kennedy L.",img:55,t:"6mo",l:6,r:"📢",b:"g",lk:false,body:"telling all my friends"},
      {n:"Luna M.",img:56,t:"6mo",l:14,r:"🔥",b:"g",lk:false,body:"this is going viral for a reason"},
      {n:"Monica N.",img:57,t:"6mo",l:9,r:"🧪",b:"g",lk:false,body:"the science checks out"},
      {n:"Nora O.",img:58,t:"6mo",l:17,r:"⚔️",b:"g",lk:false,body:"endo warrior here, this helps"},
      {n:"Pia P.",img:59,t:"6mo",l:11,r:"⏱️",b:"g",lk:false,body:"30 mins after first gummy = relief"},
      {n:"Reagan Q.",img:60,t:"6mo",l:13,r:"❤️",b:"g",lk:false,body:"no clots this cycle"},
      {n:"Selene R.",img:61,t:"6mo",l:9,r:"✨",b:"g",lk:false,body:"skin barrier thriving"},
      {n:"Tia S.",img:62,t:"6mo",l:11,r:"🙌",b:"g",lk:false,body:"no breakouts week before period"},
      {n:"Vera T.",img:63,t:"6mo",l:14,r:"😌",b:"g",lk:false,body:"mood swings — gone"},
      {n:"Winnie U.",img:64,t:"6mo",l:16,r:"🥹",b:"g",lk:true,body:"first cycle in years where I didn't cry"},
      {n:"Annie W.",img:66,t:"6mo",l:13,r:"👩‍⚕️",b:"g",lk:false,body:"OBGYN said keep doing what you're doing"},
      {n:"Belle X.",img:67,t:"6mo",l:18,r:"🙌",b:"g",lk:false,body:"my acne is GONE"},
      {n:"Cassandra Y.",img:68,t:"6mo",l:21,r:"😱",b:"g",lk:false,body:"look 5 years younger I swear"},
      {n:"Donna Z.",img:69,t:"6mo",l:9,r:"✨",b:"g",lk:false,body:"this is the one"},
      {n:"Esme A.",img:70,t:"6mo",l:11,r:"👜",b:"g",lk:false,body:"no more painkillers in my bag"},
      {n:"Flora B.",img:1,t:"6mo",l:8,r:"💪",b:"g",lk:false,body:"going hard for PumPums"},
      {n:"Gianna C.",img:2,t:"6mo",l:14,r:"⏸️",b:"b",lk:false,body:"stop scrolling and order this"},
      {n:"Harlow D.",img:3,t:"6mo",l:10,r:"💯",b:"g",lk:false,body:"the only supplement I take now"},
      {n:"Ines E.",img:4,t:"6mo",l:9,r:"❤️",b:"g",lk:false,body:"addicted in the best way"},
      {n:"Joanna F.",img:5,t:"6mo",l:13,r:"🦸‍♀️",b:"g",lk:false,body:"this is my hero product"},
      {n:"Kira G.",img:6,t:"6mo",l:8,r:"📌",b:"g",lk:false,body:"permanent staple"},
      {n:"Lola H.",img:7,t:"6mo",l:11,r:"☀️",b:"g",lk:false,body:"added to my morning routine"},
      {n:"Miley I.",img:8,t:"6mo",l:14,r:"🙌",b:"g",lk:false,body:"PumPums squad"},
      {n:"Nyla J.",img:9,t:"6mo",l:19,r:"⏳",b:"g",lk:false,body:"anti-aging is REAL"},
      {n:"Ophelia K.",img:10,t:"6mo",l:15,r:"✨",b:"g",lk:false,body:"my skin is the best it's ever been"},
      {n:"Pearl L.",img:11,t:"6mo",l:7,r:"👍",b:"g",lk:false,body:"@JessicaR you need this"},
      {n:"Qiana M.",img:12,t:"6mo",l:11,r:"💯",b:"g",lk:false,body:"this is what I was telling you about @SarahMart"},
      {n:"Rita N.",img:13,t:"6mo",l:9,r:"👋",b:"g",lk:false,body:"tagging @AmberL she'll love this"},
      {n:"Suzy O.",img:14,t:"6mo",l:14,r:"❤️",b:"b",lk:false,body:"@bestie omg yes"},
      {n:"Tina P.",img:15,t:"6mo",l:10,r:"📢",b:"g",lk:false,body:"literally what I was talking about @lisa"},
      {n:"Una Q.",img:16,t:"6mo",l:7,r:"💌",b:"g",lk:false,body:"@mom check this out!"},
      {n:"Verity R.",img:17,t:"6mo",l:12,r:"📖",b:"g",lk:false,body:"telling my book club rn @Anna"},
      {n:"Willa S.",img:18,t:"6mo",l:16,r:"🙋‍♀️",b:"g",lk:false,body:"@SarahMartinez SAME"},
      {n:"Xiomara T.",img:19,t:"6mo",l:13,r:"✅",b:"g",lk:false,body:"Yes @Jess this is what I meant"},
      {n:"Yetta U.",img:20,t:"6mo",l:11,r:"🎯",b:"g",lk:false,body:"@KellyP this is the one I told you about"},
      {n:"Aviana W.",img:21,t:"6mo",l:8,r:"💯",b:"g",lk:false,body:"FACT @Madison"},
      {n:"Briana X.",img:22,t:"6mo",l:11,r:"📢",b:"b",lk:false,body:"@group chat: this works"},
      {n:"Celia Y.",img:23,t:"6mo",l:9,r:"👯",b:"g",lk:false,body:"@LJunior order this for your sis"},
      {n:"Dasha Z.",img:24,t:"6mo",l:7,r:"🤔",b:"g",lk:false,body:"@Hannah remember when I told you?"},
      {n:"Elise A.",img:25,t:"6mo",l:13,r:"📦",b:"g",lk:false,body:"@Stephanie ordering for you"},
      {n:"Fern B.",img:26,t:"6mo",l:14,r:"💯",b:"g",lk:false,body:"@Mia THIS IS THE ONE"},
      {n:"Genevieve C.",img:27,t:"6mo",l:8,r:"👋",b:"g",lk:false,body:"yo @Jules check this out"},
      {n:"Hattie D.",img:28,t:"6mo",l:10,r:"❤️",b:"g",lk:false,body:"@bridgetb you'll love it"},
      {n:"Ilana E.",img:29,t:"6mo",l:9,r:"🪧",b:"g",lk:false,body:"@Erica this is your sign"},
      {n:"Janelle F.",img:30,t:"6mo",l:7,r:"💁‍♀️",b:"g",lk:false,body:"@RachelD same girl"},
      {n:"Kalia G.",img:31,t:"6mo",l:13,r:"📦",b:"g",lk:false,body:"@Madison get on this"},
      {n:"Lina H.",img:32,t:"6mo",l:12,r:"🎁",b:"g",lk:false,body:"@Quinn ordering you a bottle"},
      {n:"Marisol I.",img:33,t:"6mo",l:8,r:"✅",b:"g",lk:false,body:"@Tara confirmed legit"},
      {n:"Niamh J.",img:34,t:"6mo",l:11,r:"🙋‍♀️",b:"g",lk:false,body:"@Lindsey try it"},
      {n:"Odette K.",img:35,t:"6mo",l:9,r:"📣",b:"g",lk:false,body:"OMG @Carrie yes!"},
      {n:"Petra L.",img:36,t:"6mo",l:14,r:"🤝",b:"g",lk:false,body:"@Vanessa this works trust me"},
      {n:"Querida M.",img:37,t:"6mo",l:7,r:"🙏",b:"g",lk:false,body:"@Hope please try"},
      {n:"Rashida N.",img:38,t:"6mo",l:18,r:"😭",b:"g",lk:false,body:"@AshK SAME 😭"},
      {n:"Sasha O.",img:39,t:"6mo",l:11,r:"🙏",b:"g",lk:false,body:"I get my period in 3 days and I'm not dreading it for once 🙏"},
      {n:"Tatum P.",img:40,t:"6mo",l:16,r:"👍",b:"g",lk:false,body:"Day 1 was ROUGH but day 2 with PumPums was nothing"},
      {n:"Ulani Q.",img:41,t:"6mo",l:13,r:"😅",b:"g",lk:false,body:"my friend hyped this and I rolled my eyes — wrong move"},
      {n:"Vesper R.",img:42,t:"6mo",l:11,r:"😂",b:"g",lk:false,body:"boyfriend asked what's different. don't tell him yet 😂"},
      {n:"Waverly S.",img:43,t:"6mo",l:8,r:"😆",b:"g",lk:false,body:"got the 3-pack and my sister stole half"},
      {n:"Ximena T.",img:44,t:"6mo",l:14,r:"❤️",b:"g",lk:false,body:"started 2 cycles ago. life-changing"},
      {n:"Yolanda U.",img:45,t:"6mo",l:9,r:"📱",b:"g",lk:false,body:"the FB ad got me. zero regrets."},
      {n:"Zola V.",img:46,t:"6mo",l:11,r:"😂",b:"g",lk:false,body:"ordered after my friend wouldn't stop talking about it"},
      {n:"Annika W.",img:47,t:"6mo",l:15,r:"📱",b:"g",lk:false,body:"saw this on TikTok and bought it that night"},
      {n:"Bess X.",img:48,t:"6mo",l:12,r:"🤔",b:"g",lk:false,body:"month 1: skeptical / month 3: convert"},
      {n:"Calla Y.",img:49,t:"6mo",l:18,r:"👜",b:"g",lk:false,body:"I was that girl with painkillers in every bag. not anymore."},
      {n:"Darla Z.",img:50,t:"6mo",l:10,r:"🤷‍♀️",b:"g",lk:false,body:"my therapist asked what changed. it's the gummies."},
      {n:"Edith A.",img:51,t:"6mo",l:21,r:"🥹",b:"g",lk:true,body:"took a screenshot to show my husband. he ordered it for me 🥹"},
      {n:"Fontaine B.",img:52,t:"6mo",l:14,r:"✨",b:"g",lk:false,body:"skin is doing things. period is doing things. all good."},
      {n:"Greta C.",img:53,t:"6mo",l:16,r:"🌅",b:"g",lk:false,body:"cycle from hell → cycle from heaven. no in between."},
      {n:"Hilda D.",img:54,t:"6mo",l:11,r:"❤️",b:"g",lk:false,body:"I'm 27 and this is my fav purchase of the year"},
      {n:"Inez E.",img:55,t:"6mo",l:13,r:"✨",b:"g",lk:false,body:"haven't cancelled plans during period in 4 months ✨"},
      {n:"Jolene F.",img:56,t:"6mo",l:9,r:"😂",b:"g",lk:false,body:"got my partner on it too. yes men can — for inflammation lol"},
      {n:"Kasey G.",img:57,t:"6mo",l:15,r:"⏳",b:"g",lk:false,body:"this is what I'd buy myself 10 years younger if I could"},
      {n:"Lottie H.",img:58,t:"6mo",l:12,r:"⏸️",b:"g",lk:false,body:"stop putting it off, just buy it"},
      {n:"Mirabel I.",img:59,t:"6mo",l:14,r:"📦",b:"g",lk:false,body:"subscription is the move"},
      {n:"Nadine J.",img:60,t:"6mo",l:10,r:"🥲",b:"g",lk:false,body:"thought it was too good to be true. it isn't."},
      {n:"Ottilie K.",img:61,t:"6mo",l:18,r:"💰",b:"g",lk:false,body:"the founder needs a raise"},
      {n:"Petunia L.",img:62,t:"6mo",l:7,r:"❤️",b:"g",lk:false,body:"bestest purchase ever"},
      {n:"Queenie M.",img:63,t:"6mo",l:16,r:"😭",b:"g",lk:true,body:"didn't cry last cycle. that's a first."},
      {n:"Rosalind N.",img:64,t:"6mo",l:13,r:"🙌",b:"g",lk:false,body:"no nausea, no cramping, no nothing"},
      {n:"Saskia O.",img:65,t:"6mo",l:11,r:"📦",b:"g",lk:false,body:"I've cancelled all my other supplements"},
      {n:"Trinity P.",img:66,t:"6mo",l:8,r:"😋",b:"g",lk:false,body:"the gummies actually taste fine btw"},
      {n:"Veda R.",img:68,t:"6mo",l:9,r:"🛒",b:"g",lk:false,body:"literally just bought my second bottle"},
      {n:"Wisteria S.",img:69,t:"6mo",l:14,r:"😯",b:"g",lk:false,body:"PMS bloat: gone. period weight: gone."},
      {n:"Yara U.",img:1,t:"6mo",l:15,r:"🙌",b:"g",lk:true,body:"no more crying jags before my period 😭🙌"},
      {n:"Zelda V.",img:2,t:"6mo",l:13,r:"🧠",b:"g",lk:false,body:"I have ADHD and these helped my focus too somehow"},
      {n:"Amaya W.",img:3,t:"6mo",l:18,r:"👩‍⚕️",b:"g",lk:false,body:"my OB said hormones look great"},
      {n:"Belinda X.",img:4,t:"6mo",l:14,r:"⚡",b:"g",lk:false,body:"energy is wild. I'm so much more myself"},
      {n:"Coralie Y.",img:5,t:"6mo",l:16,r:"🔁",b:"g",lk:false,body:"had to come back to leave another review"},
      {n:"Demi Z.",img:6,t:"6mo",l:12,r:"💯",b:"g",lk:false,body:"10/10 would buy again"},
      {n:"Esmé A.",img:7,t:"6mo",l:9,r:"📢",b:"g",lk:false,body:"everyone needs to know about this"},
      {n:"Fawn B.",img:8,t:"6mo",l:14,r:"😭",b:"g",lk:false,body:"I'm crying typing this"},
      {n:"Gretchen C.",img:9,t:"6mo",l:11,r:"❤️",b:"g",lk:false,body:"life-changing supplement"},
      {n:"Helen D.",img:10,t:"6mo",l:20,r:"✨",b:"g",lk:true,body:"PumPums has been the most consistent thing in my routine for half a year. Skin glowing. Cycle predictable. Worth every cent."},
      {n:"Ivory M.",img:11,t:"6mo",l:8,r:"💯",b:"g",lk:false,body:"life-saver. genuinely."},
      {n:"Joelle T.",img:12,t:"6mo",l:13,r:"❤️",b:"g",lk:false,body:"3 cycles. obsessed. ordering my mom a bottle."},
      {n:"Kendall A.",img:13,t:"6mo",l:11,r:"✨",b:"g",lk:false,body:"PumPums is my unfair advantage 🤫"}
    ];

    const BATCH_SIZE = 10;
    let visibleExtras = 0;
    let nextCol = 'left'; // alternates for each new review appended

    // Redistribute initial 12 reviews — alternate items 1,3,5,7,9,11 → left, 2,4,6,8,10,12 → right
    function redistributeInitial() {
      const left = document.getElementById('fb-col-left');
      const right = document.getElementById('fb-col-right');
      if (!left || !right) return;
      const reviews = Array.from(left.querySelectorAll('.fb-rv'));
      reviews.forEach((rv, i) => {
        if (i % 2 === 1) right.appendChild(rv); // 0,2,4,... stay left; 1,3,5,... move right
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', redistributeInitial);
    } else {
      redistributeInitial();
    }

    function escapeHtml(s) {
      return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    }

    function renderReview(r) {
      const bubbleClass = r.b === 'b' ? ' blue' : '';
      const likedAttr = r.lk ? ' class="liked"' : '';
      return '<div class="fb-rv fb-rv-extra">' +
        '<div class="fb-rv-av"><img src="https://i.pravatar.cc/80?img=' + r.img + '" alt="' + escapeHtml(r.n) + '"/></div>' +
        '<div class="fb-rv-content">' +
          '<div class="fb-rv-bubble' + bubbleClass + '">' +
            '<div class="fb-rv-name">' + escapeHtml(r.n) + '</div>' +
            '<div class="fb-rv-body">' + r.body + '</div>' +
          '</div>' +
          '<div class="fb-rv-actions">' +
            '<span' + likedAttr + '>Like</span>' +
            '<span>Reply</span>' +
            '<span>' + r.t + '</span>' +
            '<span class="like-count">' + r.r + ' ' + r.l + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    window.loadMoreComments = function() {
      const leftCol = document.getElementById('fb-col-left');
      const rightCol = document.getElementById('fb-col-right');
      const btn = document.getElementById('fb-load-more');
      const collapseWrap = document.getElementById('fb-collapse-wrap');
      const remaining = moreReviews.length - visibleExtras;
      if (remaining <= 0) return;

      const toAdd = Math.min(BATCH_SIZE, remaining);
      for (let i = 0; i < toAdd; i++) {
        const target = nextCol === 'left' ? leftCol : rightCol;
        target.insertAdjacentHTML('beforeend', renderReview(moreReviews[visibleExtras + i]));
        nextCol = nextCol === 'left' ? 'right' : 'left';
      }
      visibleExtras += toAdd;

      // Show collapse button after first expansion
      if (collapseWrap.style.display === 'none') {
        collapseWrap.style.display = 'inline';
      }

      // Update button state — flow count with the 1,247 header
      const newRemaining = moreReviews.length - visibleExtras;
      const totalVisible = 12 + visibleExtras; // 12 hardcoded + JS-rendered extras
      if (newRemaining <= 0) {
        btn.textContent = "Showing " + totalVisible + " of 1,247 · You're all caught up ✓";
        btn.style.color = '#65676b';
        btn.style.pointerEvents = 'none';
        btn.style.cursor = 'default';
      } else {
        btn.textContent = 'View ' + Math.min(BATCH_SIZE, newRemaining) + ' more comments ↓';
      }
    };

    window.collapseComments = function() {
      // Remove ALL extras across both columns
      const extras = document.querySelectorAll('.fb-rv-extra');
      extras.forEach(el => el.remove());
      visibleExtras = 0;
      nextCol = 'left'; // reset for next expansion
      const btn = document.getElementById('fb-load-more');
      btn.textContent = 'View 10 more comments ↓';
      btn.style.color = '#1877f2';
      btn.style.pointerEvents = '';
      btn.style.cursor = 'pointer';
      document.getElementById('fb-collapse-wrap').style.display = 'none';
      // Scroll back into view of the section
      document.querySelector('.fb-reviews-section').scrollIntoView({behavior:'smooth', block:'start'});
    };
  })();

/* ─── BLOCK BOUNDARY ─── */

(function(){
  var slides = document.querySelectorAll('#hrSlider .hr-slide');
  var dots   = document.querySelectorAll('#hrDots .hr-dot');
  var cur = 0, timer;
  function goTo(n) {
    slides[cur].classList.remove('hr-active'); dots[cur].classList.remove('hr-dot-active');
    cur = (n + slides.length) % slides.length;
    slides[cur].classList.add('hr-active'); dots[cur].classList.add('hr-dot-active');
  }
  dots.forEach(function(d){ d.addEventListener('click', function(){ clearInterval(timer); goTo(+d.dataset.i); timer = setInterval(function(){ goTo(cur+1); }, 5000); }); });
  timer = setInterval(function(){ goTo(cur+1); }, 5000);
})();

/* ─── BLOCK BOUNDARY ─── */

// ── Sticky Bottom CTA Bar ───────────────────────────────────
  (function() {
    const bar = document.getElementById('stickyCta');
    let shown = false;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 600 && !shown) {
        bar.classList.add('visible');
        shown = true;
      } else if (window.scrollY < 200 && shown) {
        bar.classList.remove('visible');
        shown = false;
      }
    });
  })();

  // ── Live Viewer Counter (simulated) ─────────────────────────
  // Baseline scales with time-of-day for a ~5,000 sales/day page.
  // Off-peak (2-6am): 90-180 · Morning: 220-360 · Peak (12-8pm): 420-680
  // Fluctuates ±5-18 every few seconds to feel live.
  (function() {
    const ids = ['purchaseCount', 'popupViewCount'];

    function getBaseline() {
      const h = new Date().getHours() + new Date().getMinutes() / 60;
      // Piecewise curve matching realistic traffic pattern
      if (h < 2)   return 180 + (h / 2) * 60;         // 11pm-2am: 180-240
      if (h < 5)   return 240 - ((h - 2) / 3) * 150;  // 2am-5am:  240 → 90 (trough)
      if (h < 9)   return 90  + ((h - 5) / 4) * 270;  // 5am-9am:  90 → 360
      if (h < 12)  return 360 + ((h - 9) / 3) * 100;  // 9am-noon: 360 → 460
      if (h < 15)  return 460 + ((h - 12) / 3) * 200; // noon-3pm: 460 → 660
      if (h < 20)  return 660 - ((h - 15) / 5) * 120; // 3pm-8pm:  660 → 540
      if (h < 22)  return 540 - ((h - 20) / 2) * 200; // 8pm-10pm: 540 → 340
      return        340 - ((h - 22) / 2) * 160;        // 10pm-mid: 340 → 180
    }

    let current = Math.round(getBaseline());

    function update() {
      // Drift ±5–18 toward baseline, weighted so it never strays too far
      const bl    = getBaseline();
      const delta = Math.round((bl - current) * 0.15) // pull toward baseline
                  + (Math.random() < 0.5 ? 1 : -1) * (Math.floor(Math.random() * 14) + 5);
      current = Math.max(60, Math.round(current + delta));

      ids.forEach(function(id) {
        var el = document.getElementById(id);
        if (el) el.textContent = current;
      });
    }

    update();
    // Fluctuate every 6–12 seconds randomly
    (function tick() {
      setTimeout(function() { update(); tick(); }, 6000 + Math.random() * 6000);
    })();
  })();

  // Countdown removed — formula now live

  // ── FAQ Accordion ───────────────────────────────────────────
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── Smooth scroll for anchor links ─────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── Interactive Pricing Cards ────────────────────────────────
  function selectPricingCard(el) {
    document.querySelectorAll('.pricing-card-v2').forEach(c => c.classList.remove('active'));
    el.classList.add('active');
  }

  // ── Qty Stepper ──────────────────────────────────────────────
  function changeQty(e, btn, delta) {
    e.stopPropagation(); // don't trigger selectPricingCard
    const row = btn.closest('.pc-qty-row');
    const val = row.querySelector('.pc-qty-val');
    const next = Math.max(1, (parseInt(val.textContent) || 1) + delta);
    val.textContent = next;

    // Update prices based on quantity
    const qtySection = btn.closest('.pc-qty-section');
    if (!qtySection) return;
    const baseNow = parseFloat(qtySection.getAttribute('data-base-now'));
    const baseWas = parseFloat(qtySection.getAttribute('data-base-was'));

    if (!isNaN(baseNow)) {
      const total = (baseNow * next).toFixed(2);
      const [dollars, cents] = total.split('.');
      const priceEl = qtySection.querySelector('.pc-price');
      if (priceEl) {
        // If cents are 00 (round number), drop them entirely
        if (cents === '00') {
          priceEl.innerHTML = '<sup>$</sup>' + dollars;
        } else {
          priceEl.innerHTML = '<sup>$</sup>' + dollars + '<span class="pc-cents">.' + cents + '</span>';
        }
      }
    }
    if (!isNaN(baseWas)) {
      const wasTotal = (baseWas * next).toFixed(2);
      const [wasDollars, wasCents] = wasTotal.split('.');
      const wasEl = qtySection.querySelector('.pc-original-price');
      if (wasEl) wasEl.textContent = wasCents === '00' ? '$' + wasDollars : '$' + wasTotal;
    }

    // Update cart URL on the matching card's CTA button to include quantity
    const card = btn.closest('.pricing-card-v2');
    if (card) {
      const cta = card.querySelector('.btn-add-cart');
      if (cta) {
        cta.setAttribute('data-qty', next);
        if (cta.href) {
          cta.href = cta.href.replace(/(:)\d+(\?|$)/, '$1' + next + '$2');
        }
      }
    }
  }

  // ── Pre-warm session cookies on Shopify so first Buy Now click works
  //    without being challenged by Cloudflare / Shopify bot protection ─────────
  (function primeSession() {
    if (!/lovepumpums\.com$/i.test(location.hostname) && !/myshopify\.com$/i.test(location.hostname)) return;
    function prime() {
      try { fetch('/cart.js', {credentials: 'same-origin', cache: 'no-store'}).catch(function(){}); } catch (e) {}
    }
    if (document.readyState === 'complete') {
      setTimeout(prime, 300);
    } else {
      window.addEventListener('load', function(){ setTimeout(prime, 300); });
    }
  })();

  // ── Buy Now: skip cart page, go direct to checkout with selling_plan ────────
  function buyNow(e, btn) {
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.getAttribute('data-variant');
    const sellingPlan = btn.getAttribute('data-plan');
    const qty = parseInt(btn.getAttribute('data-qty') || '1', 10);

    // Local preview fallback: if not on Shopify domain, just navigate to the href
    if (!/lovepumpums\.com$/i.test(location.hostname) && !/myshopify\.com$/i.test(location.hostname)) {
      window.location = btn.href;
      return false;
    }

    // Visual feedback
    const originalText = btn.textContent;
    btn.style.opacity = '0.7';
    btn.style.pointerEvents = 'none';
    btn.textContent = 'Adding to cart...';

    // Build POST body — selling_plan goes in items[].selling_plan (Shopify spec)
    const body = {
      items: [{
        id: parseInt(variantId, 10),
        quantity: qty
      }]
    };
    if (sellingPlan) body.items[0].selling_plan = parseInt(sellingPlan, 10);

    // Clear cart FIRST, then add new item, then redirect — prevents accumulation
    fetch('/cart/clear.js', {method: 'POST', credentials: 'same-origin'})
      .then(() => fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify(body)
      }))
      .then(r => r.json())
      .then(data => {
        if (data.status && data.status >= 400) {
          throw new Error(data.description || 'Add to cart failed');
        }
        window.location = '/checkout';
      })
      .catch(err => {
        console.warn('Fetch path failed (cold Cloudflare session), falling back to cart permalink with return_to:', err);
        // Just let the browser navigate to the href, which is /cart/{vid}:{qty}?selling_plan={plan}&return_to=/checkout
        // Browser handles this as a normal page navigation — Cloudflare challenge resolves cleanly
        // Shopify processes the URL: adds item with selling_plan, then redirects to /checkout
        window.location = btn.href;
      });

    return false;
  }

  // ── Ships Today + Smart Countdown ───────────────────────────
  (function() {
    function getNextCutoff() {
      const now = new Date();
      // Try 6am then 4pm in user's local time
      const cutoffHours = [6, 16];
      for (const h of cutoffHours) {
        const t = new Date(now);
        t.setHours(h, 0, 0, 0);
        if (t > now) return t;
      }
      // Past 4pm — count down to midnight
      const midnight = new Date(now);
      midnight.setDate(midnight.getDate() + 1);
      midnight.setHours(0, 0, 0, 0);
      return midnight;
    }

    function updateShipsToday() {
      const now = new Date();
      const dateStr = now.toLocaleDateString('en-US', {
        weekday: 'short', month: 'long', day: 'numeric'
      });
      const target = getNextCutoff();
      const diff = Math.max(0, target - now);
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      const timer = String(h).padStart(2,'0')+':'+String(m).padStart(2,'0')+':'+String(s).padStart(2,'0');
      // Legacy single elements
      const dateEl = document.getElementById('ships-date');
      if (dateEl) dateEl.textContent = dateStr;
      const cdEl = document.getElementById('ships-countdown');
      if (cdEl) cdEl.textContent = timer;
      // In-card elements
      document.querySelectorAll('.ships-date-inline').forEach(el => el.textContent = dateStr);
      document.querySelectorAll('.ships-countdown-inline').forEach(el => el.textContent = timer);
    }

    updateShipsToday();
    setInterval(updateShipsToday, 1000);
  })();

  // ── Scratch-Off Popup (email capture + checkout flow) ────────
  function closeScratchPopup() {
    document.getElementById('scratchPopup').classList.remove('spv-visible');
    try { localStorage.setItem('pp_exit_popup_dismissed', Date.now().toString()); } catch(e) {}
  }
  function closeScarcityPopup() {
    var el = document.getElementById('scarcityPopup');
    if (el) el.classList.remove('sp-visible');
    try { localStorage.setItem('pp_exit_popup_dismissed', Date.now().toString()); } catch(e) {}
  }

  // ── Scratch-canvas mechanics ──────────────────────────────────
  let scratchInited = false, scratchRevealed = false;
  function initScratch() {
    if (scratchInited) return;
    scratchInited = true;
    const canvas = document.getElementById('spvCanvas');
    if (!canvas) return;
    const wrap = canvas.parentElement;
    function sizeCanvas() {
      const w = wrap.offsetWidth, h = wrap.offsetHeight;
      const dpr = window.devicePixelRatio || 1;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      const ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);
      // Fill with peach gradient
      const grad = ctx.createLinearGradient(0, 0, w, h);
      grad.addColorStop(0, '#FFB590');
      grad.addColorStop(0.5, '#FF9F73');
      grad.addColorStop(1, '#E8956D');
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, w, h);
      // Add SCRATCH HERE label
      ctx.fillStyle = 'rgba(255,255,255,0.95)';
      ctx.font = '800 18px Montserrat, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('SCRATCH HERE', w / 2, h / 2);
      // Sparkle decorations
      ctx.font = '24px serif';
      ctx.fillText('✨', w / 2 - 80, h / 2 - 20);
      ctx.fillText('✨', w / 2 + 80, h / 2 + 20);
    }
    sizeCanvas();
    window.addEventListener('resize', sizeCanvas);

    const ctx = canvas.getContext('2d');
    let isScratching = false;

    function getPos(e) {
      const rect = canvas.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
      return { x, y };
    }

    function scratchAt(x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(x, y, 28, 0, Math.PI * 2);
      ctx.fill();
      // Also draw a small connecting line for smoother scratching
    }

    function start(e) {
      isScratching = true;
      const p = getPos(e);
      scratchAt(p.x, p.y);
      e.preventDefault && e.preventDefault();
    }
    function move(e) {
      if (!isScratching) return;
      e.preventDefault && e.preventDefault();
      const p = getPos(e);
      scratchAt(p.x, p.y);
      checkRevealed();
    }
    function end() {
      if (isScratching) checkRevealed();
      isScratching = false;
    }

    function checkRevealed() {
      if (scratchRevealed) return;
      const w = canvas.width, h = canvas.height;
      const imageData = ctx.getImageData(0, 0, w, h);
      let transparent = 0;
      const total = w * h;
      // Sample every 16th pixel for speed
      for (let i = 3; i < imageData.data.length; i += 64) {
        if (imageData.data[i] === 0) transparent++;
      }
      const pct = transparent / (total / 16);
      if (pct > 0.40) {
        scratchRevealed = true;
        // Smooth fade-out of canvas, then reveal email form
        canvas.style.transition = 'opacity 0.4s ease';
        canvas.style.opacity = '0';
        setTimeout(function() {
          document.getElementById('spvBox').classList.add('spv-revealed');
        }, 450);
      }
    }

    canvas.addEventListener('mousedown', start);
    canvas.addEventListener('mousemove', move);
    canvas.addEventListener('mouseup', end);
    canvas.addEventListener('mouseleave', end);
    canvas.addEventListener('touchstart', start, {passive: false});
    canvas.addEventListener('touchmove', move, {passive: false});
    canvas.addEventListener('touchend', end);
  }

  // ── Email submission handler — fires from scratch popup form ────
  // Mailchimp form action URL — points to "PumPums" audience (us17 data center)
  const MAILCHIMP_FORM_ACTION = 'https://gmail.us17.list-manage.com/subscribe/post?u=e18043fdb40128e253ff736ce&id=e0c2420354&f_id=000662e0f0';
  // Honeypot field name (Mailchimp anti-bot — must be empty to pass)
  const MAILCHIMP_HONEYPOT = 'b_e18043fdb40128e253ff736ce_e0c2420354';
  function submitScratchEmail(e) {
    e.preventDefault();
    const input = document.getElementById('spvEmailInputScratch');
    const btn = document.getElementById('spvClaimBtn');
    const email = (input.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      input.classList.add('spv-input-error');
      setTimeout(() => input.classList.remove('spv-input-error'), 500);
      return false;
    }
    btn.disabled = true;
    btn.textContent = 'Securing your reward...';
    if (MAILCHIMP_FORM_ACTION) {
      const fd = new FormData();
      fd.append('EMAIL', email);
      fd.append('tags', '6513877'); // Mailchimp tag ID for "Meta-LP1" — must be numeric ID, not name
      if (typeof MAILCHIMP_HONEYPOT !== 'undefined') fd.append(MAILCHIMP_HONEYPOT, '');
      const params = new URLSearchParams(location.search);
      if (params.get('utm_source')) fd.append('MMERGE3', params.get('utm_source'));
      if (params.get('utm_campaign')) fd.append('MMERGE4', params.get('utm_campaign'));
      try { fetch(MAILCHIMP_FORM_ACTION, {method: 'POST', mode: 'no-cors', body: fd}).catch(()=>{}); } catch(e) {}
    }
    try { localStorage.setItem('pp_captured_email', email); } catch(e) {}
    try { localStorage.setItem('pp_exit_popup_dismissed', Date.now().toString()); } catch(e) {}
    const VARIANT_ID = '52054675620120';
    const SELLING_PLAN = '6893437208';
    const url = '/cart/' + VARIANT_ID + ':1?selling_plan=' + SELLING_PLAN +
                '&return_to=' + encodeURIComponent('/checkout?checkout[email]=' + encodeURIComponent(email)) +
                '&attributes[captured_email]=' + encodeURIComponent(email);
    if (!/lovepumpums\.com$/i.test(location.hostname) && !/myshopify\.com$/i.test(location.hostname)) {
      alert('Email captured: ' + email + '\n\nOn the live site, this would redirect to checkout with the 3-Bottle Bundle.');
      btn.disabled = false;
      btn.textContent = 'Claim My Reward';
      return false;
    }
    window.location = 'https://lovepumpums.com' + url;
    return false;
  }
  window.submitScratchEmail = submitScratchEmail;

  // ── Email submission handler — fires from the urgency popup form ────────
  // NEW FLOW (May 16, 2026): Loading → Congrats success card + confetti →
  // popup auto-fades → smooth-scroll to #bundle-cards with 3-bottle pulse-highlighted.
  // We do NOT redirect to checkout anymore — the user picks their bundle themselves.
  function submitEmailCapture(e) {
    e.preventDefault();
    const input = document.getElementById('spEmailInput');
    const btn = document.getElementById('spSubmitBtn');
    const email = (input.value || '').trim();
    // Simple email validation
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      input.classList.add('sp-input-error');
      setTimeout(() => input.classList.remove('sp-input-error'), 500);
      return false;
    }
    // Lock the button to prevent double-submit
    btn.disabled = true;
    btn.textContent = 'Securing your spot...';

    // 1) Send email to Mailchimp + auto-tag as "Meta-LP1" for segmentation
    if (MAILCHIMP_FORM_ACTION) {
      const fd = new FormData();
      fd.append('EMAIL', email);
      fd.append('tags', '6513877'); // Mailchimp tag ID for "Meta-LP1" — must be numeric ID, not name
      if (typeof MAILCHIMP_HONEYPOT !== 'undefined') fd.append(MAILCHIMP_HONEYPOT, '');
      const params = new URLSearchParams(location.search);
      if (params.get('utm_source'))    fd.append('MMERGE3', params.get('utm_source'));
      if (params.get('utm_campaign'))  fd.append('MMERGE4', params.get('utm_campaign'));
      try {
        fetch(MAILCHIMP_FORM_ACTION, {method: 'POST', mode: 'no-cors', body: fd}).catch(()=>{});
      } catch(err) {}
    }
    // 2) Store in localStorage so we know they captured (used by later attribution)
    try { localStorage.setItem('pp_captured_email', email); } catch(err) {}
    // 3) Mark popup as dismissed so it doesn't re-fire on this device
    try { localStorage.setItem('pp_exit_popup_dismissed', Date.now().toString()); } catch(err) {}

    // 4) Run the success animation sequence: loading → congrats → fade → scroll
    runEmailCaptureSuccess();
    return false;
  }
  window.submitEmailCapture = submitEmailCapture;

  // ═══════════════ SPIN-TO-WIN POPUP ═══════════════
  // Wheel always lands on "35% OFF" (top segment, sage color — the grand prize)
  let spinning = false;
  window.startSpin = function() {
    if (spinning) return;
    spinning = true;
    const wheel = document.getElementById('spinWheel');
    const btn   = document.getElementById('spinBtn');
    if (!wheel || !btn) return;
    btn.disabled = true;
    // Update inner text span so we don't blow away the .spin-btn-shine layer
    const btnText = btn.querySelector('.spin-btn-text');
    if (btnText) btnText.textContent = 'Spinning…'; else btn.textContent = 'Spinning…';
    // 35% OFF is at the TOP segment (0° centered, sage). Rotate 5 full spins (1800°).
    // Small random jitter (±10°) so it feels organic but stays on 35% slice (60° wide).
    const jitter = (Math.random() * 20) - 10;
    wheel.style.transform = `rotate(${1800 + jitter}deg)`;
    // After spin animation (4.6s + 0.4s buffer), reveal step 2
    setTimeout(function() {
      document.getElementById('spinStep1').style.display = 'none';
      document.getElementById('spinStep2').style.display = 'block';
      spinning = false;
      if (typeof window.launchConfetti === 'function') {
        const box = document.querySelector('.spin-right');
        try { window.launchConfetti(box); } catch(e) {}
      }
    }, 5000);
  };

  window.submitSpinEmail = function(e) {
    e.preventDefault();
    const input = document.getElementById('spinEmailInput');
    const btn   = document.getElementById('spinClaimBtn');
    const email = (input.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      input.style.borderColor = '#e63946';
      setTimeout(() => { input.style.borderColor = ''; }, 800);
      return false;
    }
    btn.disabled = true;
    btn.textContent = 'Claiming…';
    // POST to Mailchimp (same setup as submitEmailCapture)
    if (typeof MAILCHIMP_FORM_ACTION !== 'undefined' && MAILCHIMP_FORM_ACTION) {
      const fd = new FormData();
      fd.append('EMAIL', email);
      fd.append('tags', '6513877'); // Meta-LP1 tag
      if (typeof MAILCHIMP_HONEYPOT !== 'undefined') fd.append(MAILCHIMP_HONEYPOT, '');
      const params = new URLSearchParams(location.search);
      if (params.get('utm_source'))    fd.append('MMERGE3', params.get('utm_source'));
      if (params.get('utm_campaign'))  fd.append('MMERGE4', params.get('utm_campaign'));
      try { fetch(MAILCHIMP_FORM_ACTION, {method: 'POST', mode: 'no-cors', body: fd}).catch(()=>{}); } catch(err) {}
    }
    try { localStorage.setItem('pp_captured_email', email); } catch(err) {}
    try { localStorage.setItem('pp_exit_popup_dismissed', Date.now().toString()); } catch(err) {}
    try { localStorage.setItem('pp_spin_discount', '35'); } catch(err) {}
    // Reveal step 3 — success confirmation (no code; discount auto-applies at checkout)
    setTimeout(function() {
      document.getElementById('spinStep2').style.display = 'none';
      document.getElementById('spinStep3').style.display = 'block';
    }, 600);
    return false;
  };

  // ── Success animation sequence (fires after Mailchimp POST flies) ──
  // Orchestrates: show loader, then success card, fire confetti, fade popup, scroll to bundle.
  function runEmailCaptureSuccess() {
    const popup    = document.getElementById('scarcityPopup');
    const loading  = document.getElementById('spLoadingOverlay');
    const success  = document.getElementById('spSuccessCard');
    if (!popup || !loading || !success) return;

    // Phase 1 — show loading overlay for ~900ms (feels like real work happened)
    loading.classList.add('sp-loading-visible');
    loading.setAttribute('aria-hidden', 'false');

    setTimeout(function() {
      // Phase 2 — swap to the success card, fire confetti from popup center
      loading.classList.remove('sp-loading-visible');
      loading.setAttribute('aria-hidden', 'true');
      success.classList.add('sp-success-visible');
      success.setAttribute('aria-hidden', 'false');

      // Fire confetti centered on the popup box
      if (typeof window.launchConfetti === 'function') {
        const box = popup.querySelector('.sp-box') || success;
        try { window.launchConfetti(box); } catch(err) {}
      }

      // Phase 3 — after letting them read the success card, fade popup + scroll
      setTimeout(function() {
        popup.classList.remove('sp-visible');
        // wait for the 0.4s fade transition to finish before scrolling
        setTimeout(function() {
          scrollToBundleAndHighlight();
          // Reset the popup internals so future testpopup re-opens cleanly
          success.classList.remove('sp-success-visible');
          success.setAttribute('aria-hidden', 'true');
        }, 420);
      }, 1900);
    }, 900);
  }

  // ── Smooth-scroll to bundles + pulse-highlight the 3-bottle card ──
  function scrollToBundleAndHighlight() {
    const bundles = document.getElementById('bundle-cards');
    if (!bundles) return;
    // Scroll bundles into view, then highlight the first (3-bottle) card
    bundles.scrollIntoView({behavior: 'smooth', block: 'start'});
    // Wait for scroll to settle before pulsing (~700ms typical)
    setTimeout(function() {
      const threeBottle = bundles.querySelector('.pricing-card-v2');
      if (!threeBottle) return;
      threeBottle.classList.add('bundle-pulse-highlight');
      // Remove the class after the 3 pulse cycles finish (~5s) so it can re-trigger later
      setTimeout(function() {
        threeBottle.classList.remove('bundle-pulse-highlight');
      }, 5200);
    }, 700);
  }
  window.scrollToBundleAndHighlight = scrollToBundleAndHighlight;

  (function() {
    let shown = false;
    let pageStartTime = Date.now();
    let maxScroll = 0;

    // Suppression: don't re-show if dismissed in last 7 days
    function isSuppressed() {
      try {
        const t = parseInt(localStorage.getItem('pp_exit_popup_dismissed') || '0', 10);
        if (!t) return false;
        const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
        return (Date.now() - t) < SEVEN_DAYS_MS;
      } catch(e) { return false; }
    }

    function showScarcityPopup(force) {
      if (!force && (shown || isSuppressed())) return;
      shown = true;
      // Open the original urgency + email capture popup
      const popup = document.getElementById('scarcityPopup');
      if (popup) {
        // Sync viewer count + scarcity data into popup
        const pageCount = document.getElementById('purchaseCount');
        const popupCount = document.getElementById('popupViewCount');
        if (pageCount && popupCount) popupCount.textContent = pageCount.textContent;
        const srcCount = document.getElementById('daily-purchase-count');
        const srcMonth = document.getElementById('scarcity-month');
        const popDailyCount = document.getElementById('popupDailyCount');
        const popMonth = document.getElementById('popupScarcityMonth');
        if (srcCount && popDailyCount) popDailyCount.textContent = srcCount.textContent;
        if (srcMonth && popMonth) popMonth.textContent = srcMonth.textContent;
        popup.classList.add('sp-visible');
      }
    }
    // Expose globally so it can be called from console
    window.testPopup = function() { shown = false; showScarcityPopup(true); };

    // ?testpopup=1 in URL → force-trigger after page load (handy for demos)
    if (location.search.indexOf('testpopup') > -1) {
      setTimeout(function() { window.testPopup(); }, 500);
    }

    // ─── DESKTOP TRIGGER: classic exit-intent (mouse leaves at top) ───
    // Listen on both document AND html element for max browser compatibility
    function exitIntentHandler(e) {
      // Only fire when truly leaving toward top of viewport (negative or very small Y)
      if (e.clientY <= 10 || e.clientY === undefined) {
        showScarcityPopup();
      }
    }
    document.documentElement.addEventListener('mouseleave', exitIntentHandler);
    document.addEventListener('mouseout', function(e) {
      // Only when leaving the viewport entirely (relatedTarget is null)
      if (!e.relatedTarget && (e.clientY <= 10 || e.clientY === undefined)) {
        showScarcityPopup();
      }
    });

    // ─── MOBILE TRIGGER 1: scroll-up after light engagement (more aggressive) ─
    let lastScrollY = 0;
    let scrolledDownPast = false;
    let scrollUpStartY = 0;
    function onScroll() {
      const y = window.scrollY || document.documentElement.scrollTop;
      const docH = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight) - window.innerHeight;
      const pct = docH > 0 ? (y / docH) : 0;
      maxScroll = Math.max(maxScroll, pct);
      // Engaged after scrolling past just 20% (was 40%)
      if (pct > 0.20) scrolledDownPast = true;
      // Upward scroll triggers if >25% of viewport (was 40%)
      if (scrolledDownPast && y < lastScrollY) {
        if (scrollUpStartY === 0) scrollUpStartY = lastScrollY;
        const upDelta = scrollUpStartY - y;
        const upDeltaPct = upDelta / window.innerHeight;
        if (upDeltaPct > 0.25) {
          showScarcityPopup();
        }
      } else if (y > lastScrollY) {
        scrollUpStartY = 0;
      }
      lastScrollY = y;
    }
    window.addEventListener('scroll', onScroll, {passive: true});

    // ─── MOBILE TRIGGER 2: 25 seconds on page (was 45) ──────────────────
    setTimeout(function() {
      if (maxScroll > 0.10) showScarcityPopup();
    }, 25000);

    // ─── MOBILE TRIGGER 3: time-based regardless of scroll (safety net) ─
    setTimeout(function() { showScarcityPopup(); }, 60000);

    // ─── BROWSER-BACK TRIGGER ───────────────────────────────────────────
    history.pushState({popup: true}, '', location.href);
    window.addEventListener('popstate', function onPop() {
      showScarcityPopup();
      history.pushState({popup: true}, '', location.href);
    });
  })();

  // ── Purchase Notification Popup ─────────────────────────────
  (function() {
    const femaleNames = [
      'Emma','Olivia','Ava','Sophia','Isabella','Mia','Charlotte','Amelia',
      'Harper','Evelyn','Abigail','Emily','Elizabeth','Mila','Ella','Luna',
      'Sofia','Camila','Aria','Scarlett','Victoria','Madison','Layla','Penelope',
      'Riley','Zoey','Nora','Lily','Eleanor','Hannah','Lillian','Addison',
      'Aubrey','Ellie','Stella','Natalie','Zoe','Leah','Hazel','Violet',
      'Aurora','Savannah','Audrey','Brooklyn','Bella','Claire','Skylar','Lucy',
      'Paisley','Everly','Anna','Caroline','Nova','Genesis','Emilia','Kennedy',
      'Samantha','Maya','Willow','Kinsley','Naomi','Aaliyah','Elena','Sarah',
      'Ariana','Allison','Gabriella','Alice','Madelyn','Chloe','Autumn','Kaylee'
    ];
    const maleNames = [
      'Liam','Noah','Oliver','James','Elijah','Lucas','Mason','Logan',
      'Ethan','Aiden','Jackson','Sebastian','Mateo','Jack','Owen'
    ];
    const states = [
      'California','Texas','Florida','New York','Pennsylvania','Illinois',
      'Ohio','Georgia','North Carolina','Michigan','New Jersey','Virginia',
      'Washington','Arizona','Massachusetts','Tennessee','Indiana','Missouri',
      'Maryland','Wisconsin','Colorado','Minnesota','South Carolina','Alabama',
      'Louisiana','Kentucky','Oregon','Oklahoma','Connecticut','Iowa',
      'Utah','Nevada','Arkansas','Mississippi','Kansas','Nebraska',
      'New Mexico','Idaho','Hawaii','Maine','Montana','Rhode Island',
      'Delaware','North Dakota','South Dakota','Alaska','Wyoming'
    ];
    const products = [
      'PumPums 3-Bottle Bundle','PumPums 5-Bottle Bundle','PumPums 1-Bottle','PumPums 3-Bottle Bundle'
    ];
    const avatarEmojis = ['🌸','💕','✨','🌺','💫','🌷','💖','🌻','🦋','💝'];

    function getRandom(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

    function showPopup() {
      const isFemale = Math.random() < 0.85;
      const name = isFemale ? getRandom(femaleNames) : getRandom(maleNames);
      const state = getRandom(states);
      const product = getRandom(products);
      const emoji = getRandom(avatarEmojis);
      const popup = document.getElementById('purchasePopup');
      popup.querySelector('.pp-avatar').textContent = emoji;
      popup.querySelector('.pp-name').textContent = name + ' from ' + state;
      popup.querySelector('.pp-product').textContent = 'Just purchased ' + product;
      popup.querySelector('.pp-time').textContent = 'Just now';

      popup.classList.add('pp-visible');
      setTimeout(() => popup.classList.remove('pp-visible'), 5000);

      // Bump daily purchase counter each time someone "buys"
      if (window.bumpDailyPurchaseCount) window.bumpDailyPurchaseCount();
    }

    function scheduleNext() {
      const delay = Math.floor(Math.random() * 10000) + 15000; // 15–25 sec
      setTimeout(function() { showPopup(); scheduleNext(); }, delay);
    }

    // First popup after 12 seconds on page load
    setTimeout(function() { showPopup(); scheduleNext(); }, 12000);
  })();

  // ── Daily Purchase Counter ────────────────────────────────────
  // Phase 1 (12:00am–5:00am): 0 → 2,009
  // Phase 2 (5:00am–midnight): 2,009 → 4,892
  // Never goes backwards on refresh (localStorage backed).
  // Resets to 0 at midnight each day.
  (function() {
    const P1_SECS  = 5 * 3600;   // 5 hours in seconds
    const P1_MAX   = 2009;
    const P2_MAX   = 4892;
    const STORE_VAL  = 'pp_dc_val';
    const STORE_DATE = 'pp_dc_date';
    const MONTHS = ['January','February','March','April','May','June',
                    'July','August','September','October','November','December'];

    function todayKey() {
      const d = new Date();
      return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
    }

    function baseline() {
      const d = new Date();
      const secs = d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds();
      if (secs <= P1_SECS) {
        return Math.floor((secs / P1_SECS) * P1_MAX);
      } else {
        const p2Secs = secs - P1_SECS;
        const p2Total = 86400 - P1_SECS;
        return P1_MAX + Math.floor((p2Secs / p2Total) * (P2_MAX - P1_MAX));
      }
    }

    function getStored() {
      try {
        if (localStorage.getItem(STORE_DATE) !== todayKey()) {
          localStorage.setItem(STORE_DATE, todayKey());
          localStorage.setItem(STORE_VAL, '0');
          return 0;
        }
        return parseInt(localStorage.getItem(STORE_VAL) || '0', 10);
      } catch(e) { return 0; }
    }

    function saveStored(val) {
      try {
        localStorage.setItem(STORE_VAL, String(val));
        localStorage.setItem(STORE_DATE, todayKey());
      } catch(e) {}
    }

    function fmt(n) { return n.toLocaleString('en-US'); }

    function render() {
      const bl      = baseline();
      const stored  = getStored();
      const count   = Math.max(bl, stored); // never go backwards
      if (count > stored) saveStored(count);

      const month = MONTHS[new Date().getMonth()];
      ['daily-purchase-count','popupDailyCount'].forEach(function(id) {
        var el = document.getElementById(id);
        if (el) el.textContent = fmt(count);
      });
      ['scarcity-month','popupScarcityMonth'].forEach(function(id) {
        var el = document.getElementById(id);
        if (el) el.textContent = month;
      });
    }

    // Each purchase popup bumps +1–3 on top of stored value
    window.bumpDailyPurchaseCount = function() {
      const bump = Math.floor(Math.random() * 3) + 1;
      saveStored(getStored() + bump);
      render();
    };

    render();
    setInterval(render, 20000); // re-check baseline every 20s
  })();

/* ─── BLOCK BOUNDARY ─── */

// ── Mobile auto-scroll to pricing on load (DISABLED — cold FB traffic should see full story) ──
// Previously auto-scrolled to #bundle-cards on mobile. Removed so users land at the top of the page
// and walk through the anti-aging narrative arc before reaching pricing.

/* ─── BLOCK BOUNDARY ─── */

// ── 8-Day Countdown (resets every 8 days from fixed epoch) ────────────────────
(function() {
  var EPOCH = 1735689600000; // 2025-01-01 00:00:00 UTC
  var CYCLE = 8 * 24 * 60 * 60 * 1000;
  function tick() {
    var now = Date.now();
    var remaining = CYCLE - ((now - EPOCH) % CYCLE);
    var d = Math.floor(remaining / (24*60*60*1000));
    var h = Math.floor((remaining % (24*60*60*1000)) / (60*60*1000));
    var m = Math.floor((remaining % (60*60*1000)) / (60*1000));
    var s = Math.floor((remaining % (60*1000)) / 1000);
    var el;
    el = document.getElementById('cd-days');  if(el) el.textContent = d;
    el = document.getElementById('cd-hours'); if(el) el.textContent = String(h).padStart(2,'0');
    el = document.getElementById('cd-mins');  if(el) el.textContent = String(m).padStart(2,'0');
    el = document.getElementById('cd-secs');  if(el) el.textContent = String(s).padStart(2,'0');
  }
  tick();
  setInterval(tick, 1000);
})();

// ── Confetti burst on Add to Cart ─────────────────────────────────────────────
(function() {
  var COLORS = ['#f0a8be','#c84872','#8e2448','#5CAD6E','#A5D6A7','#FFD700','#fff','#FFD4CC','#ff85a1','#a8e6cf'];

  function launchConfetti(originEl) {
    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99999;';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;

    var rect = originEl.getBoundingClientRect();
    var ox = rect.left + rect.width  / 2;
    var oy = rect.top  + rect.height / 2;

    var particles = [];
    for (var i = 0; i < 140; i++) {
      var angle = Math.random() * Math.PI * 2;
      var speed = 5 + Math.random() * 14;
      var shape = Math.random();
      particles.push({
        x: ox, y: oy,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - (6 + Math.random() * 10),
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        w: 7  + Math.random() * 9,
        h: 4  + Math.random() * 5,
        rot: Math.random() * 360,
        rotV: (Math.random() - 0.5) * 12,
        grav: 0.28 + Math.random() * 0.22,
        shape: shape < 0.5 ? 'rect' : shape < 0.75 ? 'circle' : 'strip',
        alpha: 1
      });
    }

    var start = null;
    var DURATION = 3200;

    function tick(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var anyAlive = false;

      for (var j = 0; j < particles.length; j++) {
        var p = particles[j];
        p.vy += p.grav;
        p.x  += p.vx;
        p.y  += p.vy;
        p.vx *= 0.98;
        p.rot += p.rotV;
        p.alpha = Math.max(0, 1 - elapsed / DURATION * 1.3);

        if (p.alpha > 0 && p.y < canvas.height + 60) {
          anyAlive = true;
          ctx.save();
          ctx.globalAlpha = p.alpha;
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot * Math.PI / 180);
          ctx.fillStyle = p.color;
          if (p.shape === 'circle') {
            ctx.beginPath();
            ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
            ctx.fill();
          } else if (p.shape === 'strip') {
            ctx.fillRect(-p.w * 0.4, -p.h * 1.5, p.w * 0.8, p.h * 3);
          } else {
            ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          }
          ctx.restore();
        }
      }

      if (anyAlive && elapsed < DURATION + 800) {
        requestAnimationFrame(tick);
      } else {
        canvas.remove();
      }
    }
    requestAnimationFrame(tick);
  }

  // Expose globally so the email popup success flow can fire confetti too
  window.launchConfetti = launchConfetti;

  // Attach to all Add to Cart buttons (delegated so it works after dynamic renders too)
  // Use CAPTURE phase so confetti fires BEFORE buyNow() handler's stopPropagation kills the event
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.btn-add-cart');
    if (btn) launchConfetti(btn);
  }, true);
})();

/* ─── BLOCK BOUNDARY ─── */

(function() {
  if (location.search.indexOf('testpopup') === -1) return;
  function showPopup() {
    var popup = document.getElementById('scarcityPopup');
    if (popup) popup.classList.add('sp-visible');
  }
  if (document.readyState === 'complete') {
    setTimeout(showPopup, 300);
  } else {
    window.addEventListener('load', function() { setTimeout(showPopup, 300); });
  }
})();